import { Typography } from '@mui/material';

export const NoneBackofficeForm = () => {
    return (
        <div data-testid="NoneBackofficeForm">
            <Typography variant="h6"> No Back Office Software</Typography>
            {`Don't have back office software? We have partnerships with many of
            the popular solutions out there. Get in touch with us and we can
            make some recommendations.`}
        </div>
    );
};
